import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MuiPagination } from './mui-pagination.component';
import { MuiFormsModule } from '../forms';
import { FormsModule } from '@angular/forms';
import { MuiButtonModule } from '../button';


@NgModule({
  declarations: [
    MuiPagination
  ],
  exports: [
    MuiPagination
  ],
  imports: [
    CommonModule,
    FormsModule,
    MuiFormsModule,
    MuiButtonModule
  ]
})
export class MuiPaginationModule {}
